module.exports = __webpack_public_path__ + "static/media/Wrestler.a57942d1.jpg";